import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewJourneyDraft, PermissionEnum, CrudEnum, TJourneyDraftSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, useJourneyDrafts, useOrganizations, useJourneies, } from '@Hooks';
import { JourneyDraftListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const JourneyDraftList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewJourneyDraft, TJourneyDraftSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const journey_drafts = useJourneyDrafts();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  const journeies = useJourneies();
  
  useEffect(() => {
    if (!journey_drafts.loaded)
      return;
      
    setLoading(false);
    setRows((journey_drafts?.journey_drafts || []).map(row => ({ ...row, key: row.id, })));
    
  }, [journey_drafts, ]);

  const columns: ColumnsType<IPreviewJourneyDraft> = React.useMemo(() => {
    return JourneyDraftListColumns(t, navigate, false, organizations, journeies, abilities, auth, [], filters, sorter);
  }, [t, navigate, organizations, journeies, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('JOURNEY_DRAFTS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
      addBtn={abilities.canImplicit(null, CrudEnum.Insert, PermissionEnum.Journey) ? { callback: () => navigate('/admin/journey_draft/add'), } : undefined} 
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TJourneyDraftSortableListCol, order: s.order as IWithListSorterProps<IPreviewJourneyDraft, TJourneyDraftSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const JourneyDraftListView = React.memo(withList<IPreviewJourneyDraft, TJourneyDraftSortableListCol>(JourneyDraftList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
